<!-- s -->
<template>
  <div>
    <el-dialog
      title="查看日志"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="close"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <commonTable
        :loading="loading"
        :tableData="tableData"
        :rowKey="rowKey"
        :tableLabel="tableLabel"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        :pageSize="searchTxt.pageSize"
        :currentPage="searchTxt.page"
        :total="searchTxt.total"
      ></commonTable>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 日志查看弹窗组件
 * 功能：按 modelName/id/logType 分页拉取操作日志并以 commonTable 展示
 */
import { getLog } from "@/api/user";
export default {
  props: {
    modelName: {
      type: String,
      default: "base",
    },
    logType: {
      type: String,
      default: "country",
    },
    id: {
      type: Number,
      default: 1,
    },
  },
  /** 初始化时拉取日志列表 */
  created() {
    this.getList();
  },
  data() {
    return {
      loading: true,
      dialogFormVisible: true,
      tableData: [],
      renderList: {},
      titleMap: [],
      rowKey: "id",
      searchTxt: {
        modelName: "",
        id: 0,
        logType: "",
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableLabel: [],
    };
  },
  methods: {
    /** 根据后端返回的 titleMap/renderList 生成表格列配置 */
    getTableLabel() {
      this.tableLabel = this.$getTableLabel(this.titleMap, this.renderList);
      this.loading = false;
    },
    /** 重新打开日志弹窗并刷新列表 */
    lookCity(row) {
      this.dialogFormVisible = true;
      this.getList();
    },
    /** 切换每页条数并刷新列表 */
    handleSizeChange(value) {
      this.searchTxt.pageSize = value;
      this.searchTxt.page = 1;
      this.getList();
    },
    /** 切换页码并刷新列表 */
    handleCurrentChange(value) {
      this.searchTxt.page = value;
      this.getList();
    },
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("lookClick");
    },
    /** 分页查询操作日志列表 */
    getList() {
      this.searchTxt.modelName = this.modelName;
      this.searchTxt.id = this.id;
      this.searchTxt.logType = this.logType;
      getLog(this.searchTxt)
        .then((result) => {
          if (result.code == 200) {
            this.tableData = result.data.pageInfo.data;
            this.searchTxt.total = result.data.pageInfo.total;
            this.titleMap = result.data.titleMap;
            this.renderList = result.data.renderList;
            this.getTableLabel();
          }
        })
        .catch((err) => {});
    },
  },
};
</script>